import React from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '@/hooks/useNotifications';
import { cn } from '@/lib/utils';

interface NotificationBellProps {
  className?: string;
  unreadCount: number;
  openNotifications: () => void;
  isOpen: boolean;
}

export const NotificationBell: React.FC<NotificationBellProps> = ({ 
  className, 
  unreadCount, 
  openNotifications, 
  isOpen 
}) => {
  return (
    <div className="relative">
      <button
        onClick={openNotifications}
        className={cn(
          'relative p-2 text-gray-300 hover:text-white transition-colors duration-200',
          'focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-gray-900',
          'rounded-full hover:bg-gray-800',
          isOpen && 'text-red-400 bg-gray-800', // Highlight when open
          className
        )}
        aria-label={`Notifications (${unreadCount} unread)`}
        tabIndex={0}
      >
        <Bell className="w-6 h-6" />
        
        {/* Unread notifications indicator */}
        {unreadCount > 0 && (
          <div className="absolute -top-1 -right-1">
            <div className="bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center min-w-[20px]">
              {unreadCount > 99 ? '99+' : unreadCount}
            </div>
          </div>
        )}
      </button>
    </div>
  );
};
